import type { SVGProps } from "react";
// generated from SyncArrows.svg — do not edit manually
// prettier-ignore
export default function SyncArrows(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 24 24" fill="none"
  xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M13 22L20 15H2M11 2L4 9H22" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
